const FileExtension = {
  aac: 'aac',
  avi: 'avi',
  css: 'css',
  csv: 'csv',
  doc: 'doc',
  docx: 'docx',
  flv: 'flv',
  gif: 'gif',
  gz: 'gz',
  heic: 'heic',
  html: 'html',
  jpeg: 'jpeg',
  jpg: 'jpg',
  js: 'js',
  mkv: 'mkv',
  mp3: 'mp3',
  mp4: 'mp4',
  msg: 'msg',
  ogg: 'ogg',
  pdf: 'pdf',
  png: 'png',
  ppt: 'ppt',
  pptm: 'pptm',
  pptx: 'pptx',
  svg: 'svg',
  txt: 'txt',
  xls: 'xls',
  xlsm: 'xlsm',
  xlsx: 'xlsx',
  zip: 'zip',
};

export default FileExtension;
